import { gql } from "@apollo/client";

export const GET_TRANSACTIONS = gql`
  query Reports(
    $where: WalletInput!
    $limit: Int
    $skip: Int
    $orderBy: CreditSortInput
  ) {
    getAllTransactions(
      where: $where
      limit: $limit
      skip: $skip
      orderBy: $orderBy
    ) {
      reports {
        credited
        receivedMoney
        totalPaidCompleted
        chartDatas {
          _id
          amount
          description
          tag1
          tag2
          tag3
          paymentTime
          transactionId
          origin
          qrString
          appLink
          createdAt
          updatedAt
          status
          bill
          billStatus
          isClaim
          remark
          isMerchantIdPayment
          isAffialiatePayment
        }
      }
      data {
        _id
        amount
        description
        tag1
        tag2
        tag3
        paymentTime
        transactionId
        origin
        qrString
        appLink
        createdAt
        updatedAt
        status
        bill
        billStatus
        remark
        isMerchantIdPayment
        isAffialiatePayment
      }
      total
    }
  }
`;

export const GET_INVOICE_CREDITS = gql`
  query BillData(
    $limit: Int
    $skip: Int
    $orderBy: CreditSortInput
    $where: WalletInput!
  ) {
    getInvoicesCredits(
      limit: $limit
      skip: $skip
      orderBy: $orderBy
      where: $where
    ) {
      billData {
        id
        status
        billNo
        price
        amount
        totalPrice
        createdAt
        updatedAt
        approvedBy
        code
        paymentData
        shop
        shopName
        paySlip
        note
        currency
      }
      total
    }
  }
`;
